export const paymentsObj = {
  title: 'Payment',
  heightLight: 'methods',
  payments: ['airtel', 'maestro', 'mastercard', 'neteller', 'paysafecard', 'skrill', 'visa', 'wirecard'],
};